import React, { useReducer, useEffect } from 'react';
import { Form, Button } from 'semantic-ui-react';
import ReactInputMask from 'react-input-mask';
import history from 'services/history';
import { paramsToSearchURL } from 'utils';

const initialState = {
    sistema: '',
    funcionario: '',
    dataInicial: '',
    dataFinal: '',
};

function formReducer(state, action) {
    if (action?.type === 'reset') {
        return initialState;
    } else {
        return { ...state, ...action.payload };
    }
}

export default function FilterForm(props) {
    const { funcionarios, location, search, onSubmit } = props;

    const [form, setForm] = useReducer(formReducer, initialState);

    const sistemasOptions = [
        // { text: 'DPNet', value: 'dpnet' },
        { text: 'Intranet', value: 'intranet' },
        { text: 'Análise Fiscal', value: 'analisefiscal' },
        { text: 'Biblioteca Virtual', value: 'bibliotecavirtual' },
    ];

    useEffect(() => {
        const params = Object.fromEntries(
            new URLSearchParams(location.search.replace('?=', '')).entries(),
        );
        const formKeys = Object.keys(form);
        for (const param in params) {
            if (formKeys.includes(param)) {
                if (form[param].toString() !== params[param])
                    setForm({ payload: { [param]: params[param] } });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function handleChange(event, props) {
        const { name, value } = props
            ? props
            : { name: event.target.name, value: event.target.value };
        setForm({ payload: { [name]: value } });
    }

    function handleSubmit() {
        if (search !== location.search) {
            history.push({
                search: paramsToSearchURL(form, false),
            });
        } else {
            onSubmit(paramsToSearchURL(form, false));
        }
    }

    function reset() {
        setForm({ type: 'reset' });
        history.push({
            search: '',
        });
    }

    return (
        <Form size="small" onSubmit={handleSubmit} noValidate>
            <Form.Group>
                <Form.Select
                    width={3}
                    label="Sistema"
                    options={sistemasOptions}
                    selectOnBlur={false}
                    search
                    name="sistema"
                    value={form.sistema}
                    onChange={handleChange}
                />
                <Form.Select
                    width={4}
                    label="Funcionário"
                    selectOnBlur={false}
                    search
                    name="funcionario"
                    value={form.funcionario}
                    onChange={handleChange}
                    options={
                        funcionarios
                            ? funcionarios.map((it) => ({
                                  text: it.nome,
                                  value: it.Codigo.toString(),
                              }))
                            : []
                    }
                />
                <Form.Field>
                    <label htmlFor="">Data inicial</label>
                    <ReactInputMask
                        style={{ textAlign: 'center', maxWidth: 115 }}
                        mask="99/99/9999"
                        name="dataInicial"
                        value={form.dataInicial}
                        onChange={handleChange}
                    />
                </Form.Field>
                <Form.Field>
                    <label htmlFor="">Data final</label>
                    <ReactInputMask
                        style={{ textAlign: 'center', maxWidth: 115 }}
                        mask="99/99/9999"
                        name="dataFinal"
                        value={form.dataFinal}
                        onChange={handleChange}
                    />
                </Form.Field>

                <Button
                    style={{ minHeight: 40, marginTop: 'auto', marginLeft: 'auto' }}
                    type="submit"
                    color="blue"
                    icon="search"
                    compact
                    content="Buscar"
                    size="tiny"
                />

                <Button
                    type="button"
                    onClick={reset}
                    style={{ minHeight: 40, marginTop: 'auto' }}
                    color="grey"
                    icon="erase"
                    compact
                    content="Limpar"
                    size="tiny"
                />
            </Form.Group>
        </Form>
    );
}
